<template>
  <EDialog
    :append-to-body="false"
    :modal-append-to-body="true"
    :dialog-title="'公告预览'"
    :center-dialog-visible="previewVisible"
    :popup-width="'1000px'"
    show-btn
    is-show-cancel
    :is-show-confirm="false"
    cancel-button-tip="关闭"
    @resetPopupData="resetPopupData"
  >
    <div class="previewContent">
      <h1 class="previewTitle">{{ previewData.title }}</h1>
      <div class="previewDate">
        <div class="left">
          <div>发布日期 ： {{ previewData.publishTime || previewData.createTime }}</div>
          <div v-if="previewData.memberDepartment">文章来源 ： {{ previewData.memberDepartment }}</div>
          <div>
            <span class="el-icon-view"></span>
            <span class="view-num">{{ previewData.pageView }}</span>
          </div>
        </div>
        <div class="right">
          <eui-btn
            v-if="previewData.manageMentFiles && previewData.manageMentFiles.length"
            class="btn"
            @click="download"
          >
            附件下载
          </eui-btn>
        </div>
      </div>
      <div class="short-description">
        {{ previewData.shortDescription }}
      </div>
      <div class="previewContentBox" v-html="previewData.content"></div>
    </div>
  </EDialog>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';

export default {
  components: {
    EDialog,
  },
  props: {
    previewVisible: Boolean,
    previewData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    findConfig() {
      this.infovisible = true;
    },

    resetPopupData() {
      this.$emit('update:previewVisible', false);
      this.$emit('update:previewData', {});
    },

    download() {
      const [file] = this.previewData.manageMentFiles;
      const downloadRes = async () => {
        const response = await fetch(file.attachmentUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = file.attachmentName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
  },
};
</script>

<style lang="scss" scoped>
.previewContent {
  display: flex;
  flex-direction: column;
  .previewTitle {
    font-size: 16px;
    color: #333;
    margin-bottom: 20px;
  }
  .previewDate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .left {
      flex: 1;
      display: flex;
      color: #999;
      font-size: 14px;
      div {
        margin-right: 30px;
      }
      .view-num {
        margin-left: 4px;
      }
    }
  }
  .short-description {
    padding: 11px 20px;
    background-color: #fff;
    color: #666666;
    font-size: 16px;
    line-height: 32px;
    font-weight: 400;
    margin-bottom: 20px;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
  }
  .previewContentBox {
    overflow-y: auto;
    ::v-deep em {
      font-style: italic;
    }
    ::v-deep img {
      max-width: 100% !important;
    }
    ::v-deep video {
      max-width: 100%;
    }
    ::v-deep a {
      word-break: break-all;
    }
    ::v-deep table {
      border-collapse: collapse;
      td {
        border: 1px solid #ccc;
        line-height: 1.5;
        min-width: 30px;
        padding: 3px 5px;
        text-align: left;
      }
      th {
        border: 1px solid #ccc;
        line-height: 1.5;
        min-width: 30px;
        padding: 3px 5px;
        background-color: #f5f2f0;
        font-weight: 700;
        text-align: center;
      }
    }
    ::v-deep ul {
      li {
        list-style: disc;
        list-style-position: inside;
      }
    }
    ::v-deep ol {
      li {
        list-style: decimal;
        list-style-position: inside;
      }
    }

    /*::v-deep p {*/
    /*  text-indent: 0 !important;*/
    /*}*/
    ::v-deep #noticeNote {
      font-size: 14px;
    }
    ::v-deep h5 {
      font-weight: bold;
    }
  }
}

.previewContentBox ::v-deep img {
  max-width: 100%;
}
</style>
